import { UiActions } from "../constants/redux";

const state = {
  headerSize: 0,
  footerSize: 0,
  width: window.innerWidth,
  height: window.innerHeight,
  scroll: window.scrollY,
  appLoading: false,
};

const uiReducer = (initialState = state, action) => {
  const { type, data } = action;
  switch (type) {
    case UiActions.headerSize:
      return { ...initialState, headerSize: data };
    case UiActions.footerSize:
      return { ...initialState, footerSize: data };
    case UiActions.width:
      return { ...initialState, width: data };
    case UiActions.height:
      return { ...initialState, height: data };
    case UiActions.scroll:
      return { ...initialState, scroll: data };
    case UiActions.appLoading:
      return { ...initialState, appLoading: data };
    default:
      return initialState;
  }
};

export default uiReducer;
